import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { useScrollManager } from '../../hooks/useScrollManager';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import ResortMap from '../../components/ResortMap/ResortMap';
import './GettingHereIguazu.css';

const GettingHereIguazu: React.FC = () => {
  const { scrollState } = useScrollManager();
  const { setHoveredDestination } = useOverlayManager();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
  }, []);

  // Figma asset URLs
  const fullImage = '/assets/images/localhost/b511fc05b56f6f56ab808fe346dacf0108ddd079.png';
  const mapImage = '/assets/images/localhost/e81ab367ef65525aad1480d1faddeb5f7050ad91.png';
  const mapNavigation = '/assets/images/localhost/7480369bf8335012f137f5425989842c4b1fc8cf.png';
  const iguazuLogoSmall = '/assets/images/localhost/cb0c7d03b8fd9ce19313644f58103ee696e9624c.svg';
  const iguazuLogoSmall2 = '/assets/images/localhost/0501557fb03c945e93b7f590ca32f7a6f081cb88.svg';
  const markerArrow = '/assets/images/localhost/a33ba1312186de6cc92a2a3b035bfed60a30305c.svg';

  return (
    <div className="getting-here-iguazu">
      {/* Navigation - Iguazu variant (light) */}
      <UnifiedNavigation variant="light" destination="iguazu" />

      {/* Header Text Block */}
      <section className="getting-header-section" data-scroll-section>
        <div className="getting-header-content">
          <h1>How to get here</h1>
          <p>
            From Buenos Aires: LATAM and Aerolíneas Argentinas fly to International Airport of Puerto Iguazú (IGR). From destinations in Brazil: There are several flights a day from São Paulo, Rio de Janeiro and Porto Alegre to IGU. From Santiago: There is a flight from Santiago to IGU, available twice a week.
          </p>
        </div>
      </section>

      {/* Full Width Image */}
      <section className="getting-fullwidth-image" data-scroll-section>
        <div
          className="fullwidth-image-container"
          style={{ backgroundImage: `url('${fullImage}')` }}
        />
      </section>

      {/* Map Section */}
      <section className="getting-map-section" data-scroll-section>
          <ResortMap
            foregroundColor = "#F3F3F3"
            backgroundColor = "#3e5b58"

            mapImageUrl = "/assets/images/iguazu/map.png"

            heading={t('properties/iguazu:map.title')}

            fromList={
              [
                {
                  "heading": t('properties/iguazu:map.fromBuenosAires.title'),
                  "description": t('properties/iguazu:map.fromBuenosAires.description')
                },
                {
                  "heading": t('properties/iguazu:map.fromSaoPaulo.title'),
                  "description": t('properties/iguazu:map.fromSaoPaulo.description')
                },
                {
                  "heading": t('properties/iguazu:map.otherAirports.title'),
                  "description": t('properties/iguazu:map.otherAirports.description')
                }
              ]
            }
          />
      </section>

      {/* Transfer Information Block */}
      <section className="getting-transfer-section" data-scroll-section>
        <div className="transfer-content">
          <h2>
            There are no group transfers so the experience will be personalized and based on your pace.
          </h2>
          <button className="contact-button dark">
            CONTACT US
          </button>
        </div>
      </section>

      {/* Instagram Gallery */}
      <div className="instagram-section-wrapper">
        <InstagramSection />
      </div>

      {/* Footer - Iguazu variant */}
      <Footer variant="iguazu" />
    </div>
  );
};

export default GettingHereIguazu;